import { SIDEBAR_WIDTH } from "@/const";
import { useSidebarStore } from "@/stores/sidebar-store";
import { SxProps, Theme, useTheme } from "@mui/material";

export function useSidebarAnimation(): SxProps<Theme> {
  const { open, disabled } = useSidebarStore();

  const theme = useTheme();

  return {
    ml: `${open && !disabled ? SIDEBAR_WIDTH : 0}px`,
    width: `calc(100% - ${open && !disabled ? SIDEBAR_WIDTH : 0}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: open && !disabled
        ? theme.transitions.easing.easeOut
        : theme.transitions.easing.sharp,
      duration: open && !disabled
        ? theme.transitions.duration.leavingScreen
        : theme.transitions.duration.enteringScreen,
    }),
  }
}
